import { useQuery } from "@apollo/client";

import { GqlUserGetAllParams } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { UserListScreen_GetAllDocument } from "../queries.generated";

export const USERS_GET_ALL = UserListScreen_GetAllDocument;

export default function useUserListScreen_GetAll(params: GqlUserGetAllParams) {
    const { data, loading, error } = useQuery(USERS_GET_ALL, {
        variables: { params },
        errorPolicy: "all",
    });

    const queryInfo = data?.userGetAll?.queryInfo;
    const [_, total] = useCacheFilterOptions(null, queryInfo?.paginationOption.total);

    return {
        loading,
        error,
        totalRows: total,
        data: data?.userGetAll?.data,
    };
}
